import { FC } from 'react'
import ActivityFilterSlidesLoading from './ActivityFilterSlides.loading'
import { useActivityFilterSlides } from './ActivityFilterSlides.module'
import SlideFilterField from './SlideFilterField'

const ActivityFilterSlides: FC = () => {
  const { filterList, getFilterLabel, onChange, isLoading } =
    useActivityFilterSlides()

  if (isLoading) {
    return <ActivityFilterSlidesLoading />
  }

  return (
    <>
      {filterList?.map((filter, index) => {
        return (
          <SlideFilterField
            key={`${filter.name}-${index}`}
            name={filter.name}
            label={getFilterLabel(filter.name)}
            items={filter.items || []}
            onChange={(item) => {
              onChange({
                name: filter.name,
                filterItem: item,
                isCanDuplicate: filter.isCanDuplicate,
              })
            }}
          />
        )
      })}
    </>
  )
}

export default ActivityFilterSlides
